<script>
  import { Modal, ModalBody, ModalHeader } from "sveltestrap";
  import BookItemForm from "./BookItemForm.svelte";
  import { formatCurrencyAmount } from "../shared/currency.js";
  import {
    bookItemModalIsOpen,
    notifyModalClose,
    currentItem,
    currentItemType,
  } from "./stores.js";

  $: businessCode = $currentItem.business_profile;

  const toggle = () => {
    // reset modal to its original state and notify store
    showForm = false;
    notifyModalClose();
  };

  let showForm = false;
  $: isStayDo = $currentItem.room_type || $currentItem.activity_type;
  $: ctaButtonText = isStayDo
    ? "Book Direct"
    : $currentItemType == "product"
    ? "Buy"
    : "Read More";
</script>

<Modal
  class="modal-dialog-centered"
  contentClassName="rounded-lg"
  isOpen={$bookItemModalIsOpen}
  {toggle}>
  <ModalHeader {toggle}>{$currentItem.title}</ModalHeader>

  <ModalBody>
    <div class="mx-4">
      <div class="text-center pb-3">
        {#if $currentItem.image_gallery}
          <!-- create a responsive insta-like gallery -->
          <div class="embed-responsive embed-responsive-4by3">
            <iframe
              title="itemImageGallery"
              src={`${$currentItem.image_gallery}gallery/-/nav/dots/-/fit/cover/-/loop/true/-/allowfullscreen/native/-/thumbwidth/100/`}
              width="100%"
              height="250"
              allowfullscreen="true" />
          </div>
        {:else}
          <div class="text-center">
            <img
              class="embed-responsive-item"
              data-blink-uuid={$currentItem.image_link_uuid}
              data-blink-quality="lightest"
              data-blink-resize="x200"
              alt={$currentItem.title} />
          </div>
        {/if}
      </div>
    </div>
    <!-- this logic here prioritises rendering minimum_price over the deprecated 
  of pricing_text_line, this will become obsolete once the appropriate migrartion takes
  place -->
    {#if $currentItem.minimum_price}
      <p class="text-muted">
        {formatCurrencyAmount(
          $currentItem.minimum_price,
          $currentItem.minimum_price_currency
        )}
      </p>
    {:else if $currentItem.pricing_text_line}
      <p class="text-muted">{$currentItem.pricing_text_line}</p>
    {/if}
    <p class="text-wrap-newline">{$currentItem.description}</p>

    {#if showForm}
      <BookItemForm
        id={$currentItem.id}
        title={$currentItem.title}
        {businessCode}
        on:closeForm={toggle} />
    {/if}

    <div class="text-center">
      {#if $currentItem.book_now_url || $currentItem.item_url}
        <a
          class="btn btn-success"
          href={$currentItem.book_now_url || $currentItem.item_url}
          target="_blank"
          rel="noopener noreferrer">
          {ctaButtonText}
        </a>
      {:else if !showForm && isStayDo}
        <button
          class="btn btn-success"
          on:click={() => {
            showForm = true;
          }}>
          {ctaButtonText}
        </button>
      {/if}
    </div>
  </ModalBody>
</Modal>
